import { Component } from '@angular/core';

@Component({
  selector: 'app-act-rules',
  templateUrl: './act-rules.component.html',
  styleUrls: ['./act-rules.component.scss']
})
export class ActRulesComponent {

}
